import React, { useState } from "react";
import "../App.css";
import footerlogo from "../Assets/Onboardingimages/footer-log01.png";
import "./FooterSection.css";
import { TermsAndConditions } from "../Components/TermsAndUse";
import { PrivacyPolicy } from "../Components/PrivacyPolicy";

export const FooterSection = () => {
  const currentYear = new Date().getFullYear();
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  return (
    <>
      <div className="footer-section">
        <div className="footer-text">
          <div>
            <button
              type="button"
              style={{
                fontSize: "14px",
                color: "#4EC3E0",
                cursor: "pointer",
                background: "transparent",
                border: "none",
                padding: 0,
              }}
              onClick={() => setShowTerms(true)}
            >
              <u style={{ textDecoration: "none" }}>Terms And Conditions</u>
            </button>
          </div>
          <div className="footer-logo">
            <img src={footerlogo} width={40} />
          </div>
          <div>
            <button
              type="button"
              style={{
                fontSize: "14px",
                color: "#4EC3E0",
                cursor: "pointer",
                background: "transparent",
                border: "none",
                padding: 0,
              }}
              onClick={() => setShowPrivacy(true)}
            >
              <u style={{ textDecoration: "none" }}>Privacy Policy</u>
            </button>
          </div>
        </div>
        <div>
          <div className="footer-line" style={{ color: "#4EC3E0" }}>
            {" "}
          </div>

          <div className="copyright-text">
            <div style={{ fontSize: "14px", color: "white" }}>
              ©{currentYear} - Quelld | All rights reserved.
            </div>
          </div>
        </div>
      </div>

      <TermsAndConditions
        open={showTerms}
        onClose={() => setShowTerms(false)}
      />
      <PrivacyPolicy open={showPrivacy} onClose={() => setShowPrivacy(false)} />
    </>
  );
};
